import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-the-a01-gift-merit__summary" }
const _hoisted_2 = { class: "p-the-a01-gift-merit__heading" }
const _hoisted_3 = { class: "p-the-a01-gift-merit__title" }
const _hoisted_4 = { "data-translate-skip": "" }
const _hoisted_5 = ["aria-expanded"]
const _hoisted_6 = {
  id: "gift-merit-body",
  class: "p-the-a01-gift-merit__body"
}
const _hoisted_7 = {
  class: "p-the-a01-gift-merit__text",
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconCheckBoxFilled = _resolveComponent("IconCheckBoxFilled")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconArrowBottom = _resolveComponent("IconArrowBottom")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["p-the-a01-gift-merit", { 'is-open': _ctx.isOpen }]),
        style: _normalizeStyle({ '--site-color': _ctx.colorCode })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_IconBase, {
              class: "p-the-a01-gift-merit__icon",
              width: 24,
              height: 24,
              "view-box": "0 0 24 24",
              "icon-color": _ctx.colorCode
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconCheckBoxFilled)
              ]),
              _: 1
            }, 8, ["icon-color"]),
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pointName), 1),
              _cache[1] || (_cache[1] = _createTextVNode("を贈るメリット ", -1))
            ])
          ]),
          (_ctx.isSp)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "p-the-a01-gift-merit__toggle",
                "aria-expanded": _ctx.isOpen,
                "aria-controls": "gift-merit-body",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
              }, [
                _createVNode(_component_IconBase, {
                  class: "p-the-a01-gift-merit__chevron",
                  width: 24,
                  height: 24,
                  "view-box": "0 0 24 24",
                  "icon-color": "#1f2021"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconArrowBottom)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.giftMerit), 1)
        ])
      ], 6))
    : _createCommentVNode("", true)
}